import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HousingListResponse, ProvinceListRequest, SearchHousingRequest } from '../models/HousingList';

interface HousingState {
  housingList: HousingListResponse | null;
  loading: boolean;
  error: string | null;
  provineList: Array<any> | null;
}

const initialState: HousingState = {
  housingList: null,
  loading: false,
  error: null,
  provineList: null,
};

const housingSlice = createSlice({
  name: 'housing',
  initialState,
  reducers: {
    fetchHousingListStart: (state, action: PayloadAction<SearchHousingRequest>) => {
      state.loading = true;
      state.error = null;
    },
    fetchHousingListSuccess: (state, action: PayloadAction<HousingListResponse>) => {
      state.loading = false;
      state.housingList = action.payload;
      state.error = null;
    },
    fetchHousingListFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearHousingList: (state) => {
      state.housingList = null;
      state.error = null;
    },
    fetchProvineListStart: (state, action: PayloadAction<ProvinceListRequest>) => {
      state.loading = true;
      state.error = null;
    },
    fetchProvineListSuccess: (state, action: PayloadAction<any>) => {
      console.log("action.payload", action.payload);
      state.loading = false;
      state.provineList = action.payload;
      state.error = null;
    },
    fetchProvineListFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const housingActions = housingSlice.actions;
export const housingReducer = housingSlice.reducer;

// Selectors
export const selectHousingList = (state: any) => state.housing.housingList;
export const selectProvineList = (state: any) => state.housing.provineList;
export const selectLoadingHousing = (state: any) => state.housing.loading;
export const selectHousingError = (state: any) => state.housing.error;

